var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedGolden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2139_41863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3403 15.6474C30.0323 15.4406 29.754 15.1924 29.5135 14.9099C29.5313 14.5166 29.6104 14.1285 29.7478 13.7596C30.0061 12.8851 30.3278 11.7967 29.7078 10.9451C29.0833 10.0867 27.9425 10.0579 27.0259 10.0345C26.6404 10.0499 26.2546 10.0084 25.8812 9.91141C25.6758 9.5893 25.519 9.2387 25.4158 8.8709C25.11 7.99996 24.729 6.91595 23.7088 6.58439C22.7188 6.26263 21.8303 6.87394 21.0469 7.41152C20.7321 7.66288 20.3786 7.86158 20.0003 7.99992C19.6217 7.86173 19.2681 7.66301 18.9532 7.41152C18.1698 6.87347 17.2811 6.26408 16.2913 6.58439C15.2713 6.91595 14.8905 7.9994 14.5843 8.87055C14.4813 9.23652 14.3262 9.58579 14.1238 9.90763C13.7492 10.0076 13.3615 10.0502 12.9741 10.0341C12.0576 10.0575 10.9168 10.0864 10.2923 10.9447C9.67225 11.7968 9.99393 12.8851 10.2523 13.7597C10.3881 14.1267 10.4678 14.5121 10.4888 14.9028C10.2493 15.1893 9.97004 15.44 9.6595 15.6474C8.92 16.2114 8 16.9135 8 17.9999C8 19.0864 8.92 19.7885 9.65965 20.3525C9.96773 20.5593 10.246 20.8074 10.4865 21.0899C10.4687 21.4832 10.3896 21.8713 10.2522 22.2403C9.99389 23.1148 9.67217 24.2032 10.2922 25.0547C10.9167 25.9131 12.0575 25.9419 12.9741 25.9654C13.3596 25.95 13.7454 25.9915 14.1188 26.0885C14.3242 26.4106 14.481 26.7612 14.5842 27.129C14.8903 28.0001 15.2712 29.084 16.2914 29.4156C16.4722 29.4749 16.6612 29.505 16.8514 29.505C17.6193 29.505 18.3204 29.023 18.9533 28.5885C19.2681 28.3371 19.6216 28.1383 20 27.9999C20.3785 28.1381 20.7322 28.3368 21.0471 28.5883C21.8305 29.1264 22.719 29.7353 23.709 29.4155C24.729 29.0839 25.1098 28.0004 25.416 27.1293C25.519 26.7633 25.674 26.4141 25.8764 26.0922C26.2511 25.9923 26.6387 25.9496 27.0262 25.9657C27.9427 25.9423 29.0835 25.9135 29.708 25.0551C30.328 24.2031 30.0063 23.1147 29.748 22.2401C29.6122 21.8731 29.5324 21.4878 29.5114 21.097C29.751 20.8105 30.0302 20.5598 30.3408 20.3524C31.08 19.7885 32 19.0864 32 17.9999C32 16.9135 31.08 16.2114 30.3403 15.6474ZM24.4571 16.207L19.457 21.207C19.0667 21.5974 18.4336 21.5976 18.0432 21.2072L18.0429 21.207L15.5429 18.7069C15.1475 18.3214 15.1394 17.6883 15.525 17.2928C15.9105 16.8974 16.5436 16.8893 16.9391 17.2749C16.9451 17.2808 16.9511 17.2868 16.957 17.2928L18.75 19.0858L23.0429 14.7928C23.4285 14.3974 24.0616 14.3894 24.4571 14.7749C24.8525 15.1604 24.8605 15.7936 24.475 16.189C24.4691 16.1951 24.4631 16.2011 24.4571 16.207Z",
    fill: "url(#paint0_linear_2139_41863)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2139_41863",
    x1: 8.00083,
    y1: 17.9995,
    x2: 32,
    y2: 17.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B67D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#B88027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BE8B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C99D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D8B75D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ECD77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFF79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FDF49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E1C877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CCA55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BC8D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B37E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B07939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B47F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CEA961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E3CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F2E191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FBF09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFF5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57828"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2139_41863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedGolden);
export default __webpack_public_path__ + "static/media/VerifiedGolden.2f6af4c64d44751cbbc68f2305db62b4.svg";
export { ForwardRef as ReactComponent };